import { ChangeDetectorRef, Component, ElementRef, Input, NgZone, Renderer2, ViewContainerRef } from "@angular/core";
import { fromEvent, Subscription } from "rxjs";
import { WindowComponent } from "sharedFeatures/window";
import { LicenseData } from "../../../sharedModels/AuthData";
import { BuyPlanWinBodyComponent } from "./buy-plan-win-body.component";

@Component({
    selector: 'buy-plan-win',
    templateUrl: './buy-plan-win.component.html',
    styleUrls: ['../window/window.component.less']
})

export class BuyPlanWinComponent extends WindowComponent {

    LicenseData!: LicenseData;

    resizeObservable$ = fromEvent(window, 'resize');
    resizeSubscription$?: Subscription;
    disableScroll = false;
    constructor(element: ElementRef,
        r: Renderer2,
        viewContainerRef: ViewContainerRef,
        chDet: ChangeDetectorRef,
        private ngZone: NgZone
    ) {

        super(element, r, viewContainerRef, chDet);

        this.height = -1;

        this.showClose = true;

        this.title = '';

        this.cornerRadius = 0;

        this.topMargin = 20;

        this.windowContentBody = BuyPlanWinBodyComponent;
    }


    getBodyComponent(): BuyPlanWinBodyComponent {
        return <BuyPlanWinBodyComponent>super.getBodyComponent();
    }
}